import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  class: "flex gap-4 items-center justify-between lg:container mx-auto lg:gap-12",
  "aria-label": "Global"
}
const _hoisted_2 = { class: "flex items-center gap-12" }
const _hoisted_3 = { class: "flex items-center gap-6 min-w-fit" }
const _hoisted_4 = { class: "hidden lg:block" }

import { CssVarColors } from "@/shared/themes/CssVarColors.interface";
import { NavigationBaseProps } from "@/views/blocks/navigation/navigation.interfaces";
import BackgroundComponent from "@/views/blocks/navigation/shared/background/BackgroundComponent.vue";
import PrimaryButton from "@/views/blocks/shared/section/buttons/primary-button/PrimaryButton.vue";
import SecondaryButton from "@/views/blocks/shared/section/buttons/secondary-button/SecondaryButton.vue";
import LogoComponent from "@/views/blocks/navigation/shared/logo/LogoComponent.vue";
import HamburgerButton from "@/views/blocks/navigation/shared/mobile-menu/HamburgerButton.vue";
import MobileMenu from "@/views/blocks/navigation/shared/mobile-menu/MobileMenu.vue";
import NavigationItem from "@/views/blocks/navigation/shared/navigation-items/NavigationItem.vue";
import NavigationItems from "@/views/blocks/navigation/shared/navigation-items/NavigationItems.vue";
import { PageBlock } from "@/views/blocks/PageBlock.interface";
import EditableElement from "@/views/page/EditableElement.vue";
import { computed, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'WithLeftAligned',
  props: {
    block: {},
    pageColors: {},
    isPreview: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dataValues = computed(() => props.block.dataValues);
const styleValues = computed(() => props.block.styleValues);

const mobileMenuOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BackgroundComponent, {
    id: _ctx.block.webId,
    backgroundColor: styleValues.value.background,
    isPreview: _ctx.isPreview
  }, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (!dataValues.value.logo.isHidden)
            ? (_openBlock(), _createBlock(EditableElement, {
                key: 0,
                blockId: _ctx.block.id,
                "field-name": "logo"
              }, {
                default: _withCtx(() => [
                  _createVNode(LogoComponent, _normalizeProps(_guardReactiveProps(dataValues.value.logo.data)), null, 16)
                ]),
                _: 1
              }, 8, ["blockId"]))
            : _createCommentVNode("", true),
          _createVNode(NavigationItems, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataValues.value.items.data.items, (item) => {
                return (_openBlock(), _createBlock(EditableElement, {
                  blockId: _ctx.block.id,
                  "field-name": `items_${item.id}`,
                  key: item.id,
                  hideable: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(NavigationItem, _mergeProps({ ref_for: true }, item, {
                      textColor: styleValues.value.text
                    }), null, 16, ["textColor"])
                  ]),
                  _: 2
                }, 1032, ["blockId", "field-name"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!dataValues.value.button.isHidden)
              ? (_openBlock(), _createBlock(EditableElement, {
                  key: 0,
                  blockId: _ctx.block.id,
                  "field-name": "button"
                }, {
                  default: _withCtx(() => [
                    _createVNode(SecondaryButton, {
                      label: dataValues.value.button.data.label,
                      href: dataValues.value.button.data.href,
                      "text-color": styleValues.value.text,
                      "show-arrow": false,
                      class: "text-sm"
                    }, null, 8, ["label", "href", "text-color"])
                  ]),
                  _: 1
                }, 8, ["blockId"]))
              : _createCommentVNode("", true)
          ]),
          (!dataValues.value.callToActionButton.isHidden)
            ? (_openBlock(), _createBlock(EditableElement, {
                key: 0,
                blockId: _ctx.block.id,
                "field-name": "callToActionButton"
              }, {
                default: _withCtx(() => [
                  _createVNode(PrimaryButton, {
                    label: dataValues.value.callToActionButton.data.label,
                    href: dataValues.value.callToActionButton.data.href,
                    "background-color": styleValues.value.brand,
                    "text-color": '#ffffff',
                    class: "lg:block px-4 py-2.5 rounded-lg text-sm shadow-xs"
                  }, null, 8, ["label", "href", "background-color"])
                ]),
                _: 1
              }, 8, ["blockId"]))
            : _createCommentVNode("", true),
          _createVNode(HamburgerButton, {
            onOpenMenu: _cache[0] || (_cache[0] = ($event: any) => (mobileMenuOpen.value = true)),
            textColor: styleValues.value.text
          }, null, 8, ["textColor"])
        ])
      ]),
      _createVNode(MobileMenu, {
        button: dataValues.value.button,
        "call-to-action-button": dataValues.value.callToActionButton,
        "is-open": mobileMenuOpen.value,
        items: dataValues.value.items,
        logo: dataValues.value.logo,
        "style-values": styleValues.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (mobileMenuOpen.value = false))
      }, null, 8, ["button", "call-to-action-button", "is-open", "items", "logo", "style-values"])
    ]),
    _: 1
  }, 8, ["id", "backgroundColor", "isPreview"]))
}
}

})